import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Risk of dementia ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 늘어가는 치매의 위험성 ")
const _hoisted_3 = {
  key: 0,
  class: "wrapCard"
}
const _hoisted_4 = {
  key: 1,
  class: "wrapCard fill-height",
  style: {"background-color":"rgba(0, 0, 0, 0.4)"}
}

import { onMounted, ref } from "vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

const cardHeight = ref(0);
const cardTextHeight = ref(0);

const necessities = ref([
  {
    reveal: false,
    title: "코로나 19 감염 후 <br /> 치매 위험 2배 가량 증가",
    content:
      "장기간 지속되는 인지기능장애가 나타날 수 있으며 이는 노인 환자에서 치매증상을 유발할 수 있습니다. 특히 뇌혈관 질환, 무증상 알츠하이머병, 파킨슨병 등 기저 신경혈관 질환이 있는 노인환자에서 급성 섬망처럼 치매 관련 증상이 나타나는 경우가 많습니다. <br /> 출처 : 알츠하이머 협회 저널 <br /> 헬스인뉴스(http://www.healthinnews.co.kr)",
    imageUrl: require("../../assets/main/main_card_1.webp"),
  },
  {
    reveal: false,
    title: "늘어가는 치매 관리 비용",
    content:
      "보건복지부에 따르면 2017년 치매 환자 수는 72만명, 치매 관리 비용은 15조원으로 통계되었습니다. 2020년에는 환자 수 84만명, 관리비용은 19조원으로 2050년에는 303만명, 107조원으로 환자와 비용이 증가할 전망으로 발표했습니다.",
    imageUrl: require("../../assets/main/main_card_2.webp"),
  },
]);

const getHeight = (id: string) => {
  const heightElement = document.getElementById(id);
  if (!heightElement) {
    return 0;
  }
  return heightElement.clientHeight;
};

onMounted(() => {
  setTimeout(() => {
    cardHeight.value = getHeight("cardHeight");
    cardTextHeight.value = getHeight("cardTextHeight");
  }, 300);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "elevation-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_subtitle, {
        class: _normalizeClass(["font-weight-regular", { 'text-subtitle-1': _unref(xs), 'text-h6': _unref(smAndUp) }]),
        style: {"color":"#0a6cff","opacity":"1"}
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_title, {
        class: _normalizeClass(["font-weight-medium pb-8", { 'text-h5': _unref(xs) }]),
        style: {"font-size":"2.25rem"}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { justify: "space-between" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(necessities.value, (necessity, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: index,
                  cols: "12",
                  sm: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "mx-auto rounded-lg" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: necessity.imageUrl,
                          gradient: "rgba(255,255,255,.4), rgba(255,255,255,.4)",
                          cover: "",
                          height: cardHeight.value,
                          class: "rounded-lg"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_Transition, {
                              name: "fade",
                              mode: "out-in"
                            }, {
                              default: _withCtx(() => [
                                (!necessity.reveal)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                      _createVNode(_component_v_card_text, {
                                        class: _normalizeClass(["font-weight-medium text-black pa-8", { 'text-h6': _unref(xs) }]),
                                        style: _normalizeStyle([{"line-height":"1.5","font-size":"1.75rem"}, { height: cardTextHeight.value + 'px' }]),
                                        innerHTML: necessity.title
                                      }, null, 8, ["class", "innerHTML", "style"]),
                                      _createVNode(_component_v_card_actions, { style: {"flex-direction":"row-reverse","align-items":"flex-end"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            icon: "mdi-plus-circle-outline",
                                            color: "#00000099",
                                            size: "x-large",
                                            onClick: ($event: any) => (necessity.reveal = !necessity.reveal)
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_v_card_text, {
                                        class: _normalizeClass(["pa-8 text-white", { 'text-body-1': _unref(xs) }]),
                                        style: _normalizeStyle([{"line-height":"1.5","word-break":"keep-all","font-size":"1.15rem"}, { height: cardTextHeight.value + 'px' }]),
                                        innerHTML: necessity.content
                                      }, null, 8, ["class", "innerHTML", "style"]),
                                      _createVNode(_component_v_card_actions, { style: {"flex-direction":"row-reverse","align-items":"flex-end"} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            icon: "mdi-close-circle-outline",
                                            color: "#FFFFFF99",
                                            size: "x-large",
                                            onClick: ($event: any) => (necessity.reveal = !necessity.reveal)
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["src", "height"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})